import { F0Box, F0Dialog, F0Text } from '@factorialco/f0-react'
import { IncentivesSendToCompensationDocument } from 'generated/resources/graphql'
import { handleResult } from 'modules/core/lib/handleMutation'
import i18n from 'modules/core/lib/i18n'
import { useMutation } from 'modules/core/hooks/useMutation'
import app from 'modules/core/store/models/app'

interface SendToCompensationDialogProps {
  isOpen: boolean
  onClose: () => void
  periodId: string
  employeeCount: number
  periodLabel: string
}

export function SendToCompensationDialog({
  isOpen,
  onClose,
  periodId,
  employeeCount,
  periodLabel,
}: SendToCompensationDialogProps) {
  const [sendToCompensation, { loading }] = useMutation(IncentivesSendToCompensationDocument, {
    extractorFn: (data) => data.incentivesMutations.createIncentivesCompensationPlanExecution,
  })

  const handleConfirm = async () => {
    const result = await sendToCompensation({
      variables: { compensationPlanPeriodId: periodId },
    })

    const handled = handleResult(result, (errors) => {
      const errorMessage = Object.values(errors).join(', ')
      if (errorMessage) {
        app.setFlash({ type: 'wrong', message: errorMessage, time: 3000 })
      }
    })

    if (handled.success) {
      app.setFlash({
        type: 'correct',
        message: i18n.t('incentives.detail.send_to_compensation_modal.success_message'),
      })
    }

    onClose()
  }

  return (
    <F0Dialog
      isOpen={isOpen}
      title={i18n.t('incentives.detail.send_to_compensation_modal.title')}
      onClose={onClose}
      width="sm"
      primaryAction={{
        label: i18n.t('common.confirm'),
        onClick: handleConfirm,
        loading,
        variant: 'critical',
      }}
      secondaryAction={{
        label: i18n.t('common.cancel'),
        onClick: () => onClose(),
      }}
    >
      <F0Box display="flex" flexDirection="column" gap="md">
        <F0Text
          content={i18n.t('incentives.detail.send_to_compensation_modal.description', {
            periodLabel,
            employeeCount,
          })}
        />
      </F0Box>
    </F0Dialog>
  )
}
